import type { TError, TPollVoters } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../../axios';
import { ENTITY } from '../entity';

/**
 * Query key for a poll's voters (who voted for each option)
 */
export const getPollVotersQueryKey = (pollId: string) => [ENTITY, 'polls', pollId, 'voters'];

/**
 * Hook to fetch the users who voted for each option of a poll. Enable it only
 * when the voters view is open to avoid fetching for every poll in the feed.
 *
 * @param pollId - Poll ID (UUID)
 * @param enabled - Fetch only when the "who voted" view is open
 */
export const useGetPollVoters = (pollId: string, enabled: boolean = true) => {
  return useQuery<TPollVoters, TError>({
    queryKey: getPollVotersQueryKey(pollId),
    queryFn: async () => {
      const res = await axios.get<TPollVoters>(`/community-hub/polls/${pollId}/voters`);
      return res.data;
    },
    enabled: !!pollId && enabled,
    staleTime: 15 * 1000,
  });
};
